module.exports = __webpack_public_path__ + "static/media/p007.13247471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p007.jpg
// module id = 1520
// module chunks = 0